export default __webpack_public_path__ + "static/media/gold_reveal.0fca0cb2.mp3";